namespace Nobox.CRM {
    export interface GrouptargetsForm {
        GrpId: Serenity.ServiceLookupEditor;
        Years: Serenity.DateYearEditor;
        Currencies: CurrencyEditor;
        Cry: CurrencyEditor;
        Target: AutoNumericEditor;
        Jan: AutoNumericEditor;
        Feb: AutoNumericEditor;
        Mar: AutoNumericEditor;
        Apr: AutoNumericEditor;
        May: AutoNumericEditor;
        Jun: AutoNumericEditor;
        Jul: AutoNumericEditor;
        Agus: AutoNumericEditor;
        Sep: AutoNumericEditor;
        Okto: AutoNumericEditor;
        Nov: AutoNumericEditor;
        Dec: AutoNumericEditor;
    }

    export class GrouptargetsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Grouptargets';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GrouptargetsForm.init)  {
                GrouptargetsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.DateYearEditor;
                var w2 = CurrencyEditor;
                var w3 = AutoNumericEditor;

                Q.initFormType(GrouptargetsForm, [
                    'GrpId', w0,
                    'Years', w1,
                    'Currencies', w2,
                    'Cry', w2,
                    'Target', w3,
                    'Jan', w3,
                    'Feb', w3,
                    'Mar', w3,
                    'Apr', w3,
                    'May', w3,
                    'Jun', w3,
                    'Jul', w3,
                    'Agus', w3,
                    'Sep', w3,
                    'Okto', w3,
                    'Nov', w3,
                    'Dec', w3
                ]);
            }
        }
    }
}
